import React from "react";
import {
  Container,
  Box,
  Typography,
  List,
  ListItem,
  Link,
  Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next";

/* Images */
import productImage1 from "../../assets/LandingPage/ProductPageImg1.jpg";
import productImage2 from "../../assets/LandingPage/backPain.jpg";
import productImage3 from "../../assets/LandingPage/certified.jpg";

const ProductParticipantPage = () => {
  const { t } = useTranslation();

  // Arrays (mit {label, href})
  const links = t("productParticipant.links", { returnObjects: true }) || [];
  const guides = t("productParticipant.guides", { returnObjects: true }) || [];
  const literature =
    t("productParticipant.literature", { returnObjects: true }) || [];

  // Benefits (als einfache Liste von Strings)
  const benefits =
    t("productParticipant.sections.benefits.items", { returnObjects: true }) ||
    [];

  return (
    <Container
      
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
      }}
    >
      <Box
        className="white-background"
        sx={{
          width: "100%",
          maxWidth: "100%",
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          textAlign: "left",
          overflowY: "auto",
        }}
      >
        {/* Titel + Intro */}

          <Typography variant="h3" color="primary" gutterBottom >
            {t("productParticipant.title")}
          </Typography>
          <Typography variant="body1" paragraph>
            {t("productParticipant.intro")}
          </Typography>

          <Divider sx={{ my: 3 }} />

          {/* Program Overview */}
          <Box>
            <Typography variant="h5" color="primary" gutterBottom sx={{fontWeight:"bold", fontSize:30}}>
              {t("productParticipant.sections.programOverview.title")}
            </Typography>
            <Box sx={{display: "flex",  alignItems:"center", gap:20}}>
              <Typography variant="body1" paragraph sx={{textAlign:"justify"}}>
                {t("productParticipant.sections.programOverview.text")}
              </Typography>
              <img src={productImage1} alt="" style={{width:"40%", borderRadius:25}}/>
            </Box>
          </Box>
        
        <Divider sx={{ my: 3 }} />
        
        {/* Certification */}
          <Box>
            <Typography variant="h5" color="primary" gutterBottom sx={{fontWeight:"bold", fontSize:30}}>
              {t("productParticipant.sections.certification.title")}
            </Typography>
            <Box sx={{display: "flex",  alignItems:"center", gap:20, my:5}}>
            <img src={productImage3} alt="" style={{width:"40%", borderRadius:25}}/>
              <Typography variant="body1" paragraph sx={{textAlign:"justify"}}>
                {t("productParticipant.sections.certification.text")}
              </Typography>
            </Box>
          </Box>

        <Divider sx={{ my: 3 }} />
        

        {/* Benefits */}
        <Typography variant="h5" color="primary" gutterBottom sx={{fontWeight:"bold", fontSize:30, my:5}}>
          {t("productParticipant.sections.benefits.title")}
        </Typography>
        {benefits.length > 0 && (
          <List dense sx={{ 
                mb: 2, 
                display:"grid", 
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", 
                gap: 5, 
                my:7, 
                background:"rgb(25, 118, 210, 0.5)", 
                padding:7,
                borderRadius: 10,
              }}>
            {benefits.map((b, i) => (
              <Box key={i} sx={{background:"#ffffff", px:2,py:5, borderRadius: 5, boxShadow:"10px 10px"}}>
                <Typography  sx={{textAlign:"center", fontWeight:"bold"}}>{b}</Typography>
              </Box>
            ))}
          </List>
        )}

         <Divider sx={{ my: 3 }} />

        {/* Health Benefits */}
          <Box>
            <Typography variant="h5" color="primary" gutterBottom sx={{fontWeight:"bold", fontSize:30}}>
              {t("productParticipant.sections.healthBenefits.title")}
            </Typography>
            <Box sx={{display: "flex",  alignItems:"center", gap:20, my:5}}>
              <Typography variant="body1" paragraph sx={{textAlign:"justify"}}>
                {t("productParticipant.sections.healthBenefits.text")}
              </Typography>
              <img src={productImage2} alt="" style={{width:"40%", borderRadius:25}}/>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

        {/* Further Information */}
        <Typography variant="h5" color="primary" gutterBottom sx={{fontWeight:"bold", fontSize:30, my:7}}>
          {t("productParticipant.furtherInformation.title")}
        </Typography>
        <Typography variant="body1" paragraph sx={{textAlign:"justify", paddingBottom:5}}>
          {t("productParticipant.furtherInformation.subtitle")}
        </Typography>

        {/* Links */}
        {links.length > 0 && (
          <>
            <Typography variant="subtitle1" sx={{ mt: 1, fontWeight:"bold" }} gutterBottom>
              {t("productParticipant.linksTitle", "Links (15.08.2025)")}
            </Typography>
            <List dense>
              {links.map((item, idx) => (
                <ListItem key={idx} sx={{ pl: 0 }}>
                  {item.href ? (
                    <Link
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <Typography variant="body2">{item.label}</Typography>
                  )}
                </ListItem>
              ))}
            </List>
          </>
        )}

        {/* Guides */}
        {guides.length > 0 && (
          <>
            <Typography variant="subtitle1" sx={{ mt: 2,fontWeight:"bold" }} gutterBottom>
              {t("productParticipant.guidesTitle", "Guidelines & Brochures")}
            </Typography>
            
            <List dense>
              {guides.map((item, idx) => (
                <ListItem key={idx} sx={{ pl: 0 }}>
                  {item.href ? (
                    <Link
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <Typography variant="body2">{item.label}</Typography>
                  )}
                </ListItem>
              ))}
            </List>
          </>
        )}

        {/* Literature */}
        {literature.length > 0 && (
          <>
            <Typography variant="subtitle1" sx={{ mt: 2, fontWeight:"bold" }} gutterBottom>
              {t(
                "productParticipant.literatureTitle",
                "Recommended literature"
              )}
            </Typography>
            <List dense>
              {literature.map((item, idx) => (
                <ListItem key={idx} sx={{ pl: 0 }}>
                  {item.href ? (
                    <Link
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="hover"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <Typography variant="body2">{item.label}</Typography>
                  )}
                </ListItem>
              ))}
            </List>
          </>
        )}

        {/* Disclaimer */}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, fontWeight:"bold" }}>
          {t("productParticipant.furtherInformation.note")}
        </Typography>
      </Box>
    </Container>
  );
};

export default ProductParticipantPage;
